import { SortOrder, ValueSortOptions } from 'app/area/favourite/types';
import { 
  ReportDefinition, FavouriteDefinition,
  DefaultSortOrder, SortOptions } from 'app/types-shared';

export function mapSortOrder(defaultSortOrder: DefaultSortOrder[]): SortOrder[] {
  return defaultSortOrder.map(item => ({
    domainNode: {
      v: item.domainNode.value,
      d: item.domainNode.description
    },
    sortOrderType: item.sortOrderType,
    sequence: item.orderBySequence
  }));
}

export function mapDefaultSortOrder(defaultSortOrder: SortOrder[]): DefaultSortOrder[] {
  return defaultSortOrder.map(item => ({
    domainNode: {
      value: item.domainNode.v,
      description: item.domainNode.d
    },
    sortOrderType: item.sortOrderType,
    orderBySequence: item.orderBySequence
  }));
}

export function mapSortOptions(options: ValueSortOptions): SortOptions {
  return {
    sortOptions: options.sortOptions.map(item => ({
      value: item.v,
      description: item.d
    })),
    defaultSortOrder: mapDefaultSortOrder(options.defaultSortOrder)
  };
}

export function createSortOrder(
  report: ReportDefinition,
  defaultSortOrder: DefaultSortOrder[])
  : DefaultSortOrder[] {

  const mappedNewSortOrder: DefaultSortOrder[] = report && report.sort.map(item => {
    return {
      domainNode: item.domainNode,
      orderBySequence: item.sequence,
      sortOrderType: item.sortOrderType
    };
  });
  return (mappedNewSortOrder && mappedNewSortOrder.length > 0) ? mappedNewSortOrder : defaultSortOrder;
}

type FavouriteDefinitionTransform = (definition: FavouriteDefinition) => FavouriteDefinition;

export function composeDefinitionTransforms(...definitionTransforms: FavouriteDefinitionTransform[]): FavouriteDefinitionTransform {
  return definitionTransforms.reduce(
    (previous, transform) => 
      (definition) => 
        transform
          ? transform(previous(definition))
          : previous(definition)
        , definition => definition);
}
